import Input        from 'antd/lib/input';
import React          from 'react';
import connectField   from 'uniforms/connectField';
import filterDOMProps from 'uniforms/filterDOMProps';

import wrapField from 'uniforms-antd/wrapField';

const LongText = props =>
    wrapField(props, (
        <Input.TextArea
            disabled={props.disabled}
            id={props.id}
            name={props.name}
            onChange={event => props.onChange(event.target.value)}
            placeholder={props.placeholder}
            ref={props.inputRef}
            type="textarea"
            autoComplete="off"
            autosize={{minRows: props.rows ? props.rows : 3}}
            value={props.value}
            style={{color: '#666'}}
            {...filterDOMProps(props)}
        />
    ))
;

LongText.defaultProps = {rows: 5};

export default connectField(LongText);



// WEBPACK FOOTER //
// ./src/components/UI/uniforms/LongTextField.jsx